const paths = {
 cursor:'M5 2L20 13L13 14L10 21z',
 brush:'M15 3L21 9L11 19L5 13z M5 13C-1 20 2 23 8 20L11 19',
 trendline:'M4 20L20 4 M3 19h2v2H3z M19 3h2v2h-2z',
 extendedline:'M2 22L22 2 M7 15l2 2 M15 7l2 2',
 flattopbottom:'M3 5h18 M3 20L21 10',
 disjointchannel:'M3 17L18 4 M6 22L21 14',
 insidepitchfork:'M4 21L12 4 M4 12L12 15L21 7 M12 15L17 4',
 schiffpitchfork:'M3 20L15 3 M3 10L10 14L21 8 M10 14L18 3',
 modifiedschiffpitchfork:'M3 21L15 3 M3 11L11 15L22 7 M11 15L19 3 M3 11L15 3',
 fibextension:'M2 21L9 10L14 16L22 3 M10 4h12 M10 8h12 M10 12h12',
 daterange:'M3 7v12 M21 7v12 M3 12h18 M7 9l-4 3 4 3 M17 9l4 3-4 3',
 pricerange:'M6 3h12 M6 21h12 M12 3v18 M9 7l3-4 3 4 M9 17l3 4 3-4',
 dateandpricerange:'M3 3h18v18H3z M7 17L17 7 M7 11v6h6 M11 7h6v6',
 abcdpattern:'M3 20L9 4L15 15L21 3',
 xabcdpattern:'M2 8L7 20L12 3L17 16L22 7',
 elliottimpulsewave:'M2 21L6 12L10 16L14 5L18 10L22 2',
 elliottcorrectionwave:'M2 4L8 18L14 9L22 21',
 headandshoulders:'M2 20L5 10L8 16L12 3L16 16L19 10L22 20 M3 17h18',
 trianglepattern:'M2 3L22 12L2 21 M3 6L7 17L11 9L15 14L19 12',
 cypherpattern:'M2 19L7 3L12 16L17 8L22 21',
 threedrivespattern:'M2 21L6 12L9 16L13 7L16 11L20 2L22 6',

 lines:'M3 20L21 4 M3 17v3h3 M18 4h3v3',
 channels:'M3 16L18 4 M6 21L21 9 M5 19L20 7',
 pitchforks:'M5 21L13 4 M3 12L9 15L18 8 M9 15L17 2 M15 22L23 5',
 fibonacci:'M3 4H21 M3 9H16 M3 14H19 M3 20H21 M3 20L21 4',
 gann:'M3 21V3 M3 21H21 M3 21L21 3 M3 21L21 12 M3 21L12 3',
 patterns:'M2 17L7 6L12 19L17 3L22 12',
 shapes:'M4 5H20V19H4z',
 measurements:'M4 3V21 M2 5L4 3L6 5 M2 19L4 21L6 19 M9 6H21 M9 18H21 M12 4V20',
 positions:'M4 3H20V11H4z M4 11H20V21H4z M2 11H22 M8 7H16 M8 16H16',
 volume:'M3 3V21H21 M4 5H11V8H4 M4 10H19V13H4 M4 15H15V18H4',
 annotations:'M3 4H21V17H9L4 21V17H3z M7 8H17 M7 12H14',
 cycles:'M2 12Q7 0 12 12T22 12 M3 3V21 M21 3V21',
 forecasting:'M2 18L8 12L13 15L21 4 M16 4H21V9',
 ellipse:'M22 12A10 7 0 1 1 2 12A10 7 0 1 1 22 12',
 triangle:'M12 3L22 21H2z',
 rotatedrectangle:'M2 13L16 3L22 11L8 21z',
 curve:'M3 20Q3 1 21 4 M2 19H4 M20 3H22',
 arc:'M3 19A10 10 0 0 1 21 19',
 fibfan:'M3 21L21 3 M3 21L21 9 M3 21L21 15 M3 21H21',
 fibarcs:'M3 21A18 18 0 0 1 21 3 M3 21A12 12 0 0 1 15 9 M3 21A6 6 0 0 1 9 15',
 fibtimezone:'M3 3V21 M7 3V21 M13 3V21 M22 3V21 M2 12H23',
 fibcircles:'M22 12A10 10 0 1 1 2 12A10 10 0 1 1 22 12 M18 12A6 6 0 1 1 6 12A6 6 0 1 1 18 12 M14 12A2 2 0 1 1 10 12A2 2 0 1 1 14 12',
 fibspiral:'M12 12C9 12 9 8 12 8C18 8 18 17 12 17C2 17 2 3 12 3C23 3 25 21 10 22',
 fibchannel:'M2 15L18 3 M3 20L19 8 M7 23L23 11',
 gannbox:'M3 3H21V21H3z M3 3L21 21 M3 21L21 3 M3 12H21 M12 3V21',
 horizontal:'M2 12H22 M5 10V14',
 vertical:'M12 2V22 M10 5H14',
 cross:'M2 12H22 M12 2V22',
 ray:'M3 19L21 3 M15 3H21V9 M2 18H4V20H2z',
 arrow:'M3 20L21 3 M13 3H21V11',
 angle:'M3 3V21H22 M3 21L20 4 M3 15Q8 15 9 21',
 info:'M3 20L21 4 M3 20V11 M21 4H12 M13 12h1 M13 15v3',
 text:'M3 4H21 M12 4V21 M8 21H16',
 label:'M3 4H17L22 12L17 20H3z M7 9H14 M7 14H14',
 longposition:'M4 3H20V12H4z M4 12H20V21H4z M12 17V7 M9 10L12 7L15 10',
 shortposition:'M4 3H20V12H4z M4 12H20V21H4z M12 7V17 M9 14L12 17L15 14',
 regression:'M2 19L20 3 M4 22L22 6 M3 19L7 17L10 15L14 11L18 10',
};
export const DRAWING_CATEGORIES = [
 ['Lines','lines'],['Channels','channels'],['Pitchforks','pitchforks'],['Fibonacci','fibonacci'],['Gann','gann'],
 ['Patterns','patterns'],['Shapes','shapes'],['Measurements','measurements'],['Positions','positions'],
 ['Volume','volume'],['Annotations','annotations'],['Cycles','cycles'],['Forecasting','forecasting'],
];
const categoryAliases = { Position:'Positions', Rectangle:'Shapes', Cyclic:'Cycles', VolumeProfile:'Volume' };
const normalize = value=>String(value||'').toLowerCase().replace(/[^a-z0-9]/g,'');
export function drawingIcon(key) {
 const path=paths[key] || paths.shapes;
 return 'data:image/svg+xml,'+encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="${path}"/></svg>`);
}
export function presentDrawing(tool) {
 if(tool.type==='Cursor'||String(tool.type).startsWith('System:'))return {...tool};
 let category=categoryAliases[tool.category||tool.group]||tool.category||tool.group||'Shapes';
 if(/Cyclic|Sine/.test(tool.name||''))category='Cycles';
 if(!DRAWING_CATEGORIES.some(([name])=>name===category))category='Shapes';
 const name=normalize(tool.name);
 const aliases = { pitchfork:'pitchforks', fibretracement:'fibonacci', channel:'channels', extendedchannel:'fibchannel', gannfan:'gann', speedresistancefan:'fibfan', sineline:'cycles', forecast:'forecasting', rectangle:'shapes' };
 let icon=aliases[name] || (paths[name] ? name : DRAWING_CATEGORIES.find(([group])=>group===category)[1]);
 if(name.includes('horizontal'))icon='horizontal';
 else if(name.includes('vertical'))icon='vertical';
 else if(name.includes('crossline'))icon='cross';
 else if(name.includes('trendangle'))icon='angle';
 else if(name.includes('infoline'))icon='info';
 else if(name.includes('regression'))icon='regression';
 else if(name.includes('ray'))icon='ray';
 else if(name.includes('arrow'))icon='arrow';
 else if(name.includes('text'))icon='text';
 else if(name.includes('callout')||name.includes('label'))icon='label';
 return {...tool,group:category,category,icon:drawingIcon(icon)};
}
export function drawingGroups(tools) {
 const groups=[];
 for(const input of tools || []){
  const tool=presentDrawing(input);
  if(!tool.group){groups.push(tool);continue;}
  let group=groups.find(group=>group.group===tool.group);
  if(!group){group={group:tool.group,icon:tool.icon,items:[]};groups.push(group);}
  // Preserve type identifiers even where two menu entries have similar names.
  if(!group.items.some(item=>item.type===tool.type))group.items.push(tool);
 }
 const order=['Cursor',...DRAWING_CATEGORIES.map(([name])=>name),'System'];
 return groups.sort((a,b)=>(order.indexOf(a.group||a.type)<0?99:order.indexOf(a.group||a.type))-(order.indexOf(b.group||b.type)<0?99:order.indexOf(b.group||b.type)));
}
